module.exports = __webpack_public_path__ + "static/media/sajjad.48ede0bc.jpeg";